
import Vue from "vue";
import { IDataTableColumn, ISelectItem } from "winfakt-vue-components";
import { PriceListProductService } from "@/services/price-list-product-service";
import AppImportCsvModal from "./ImportCsvModal.vue";
import {ProductService} from "@/services";
import AppExcelMapper from "./ExcelMapperWrapper.vue";
import AppTag from "@/components/common/Tag.vue";
import { Contact } from "@/models/base";
import AppContactSearch from "@/components/contacts/ContactSearch.vue";
import { HttpError } from "@/utils/services/http-error";
import { MongoView, MongoViewTypes } from "@/models/mongo-view";
import { MongoViewService } from "@/services/mongo-view-service";
import { getDefaultPriceListView, getPriceListViewColumns } from "@/utils/price-list/price-list-view-columns";
import AppViewsEditModal from "./ViewsEditModal.vue";
import { UserConfigService } from "@/services";


export default Vue.extend({
	data(){
		return {
			selectedItems: [] as any[],
			items: [] as any[],
			totalItems: 0,
			searchText: "",
			searchQuery: "",
			limit: 250,
			orderColumn: "Sku",
			orderAsc: true,
			isFetching: false,
			importModalOpen: false,
			excelMapperOpen: false,
			PriceListProductService,
			contact: null as null | Contact,
			showContactSearch: UserConfigService.getGeneralSettings().ShowSupplierFilterOnPriceListOpen,
			supplierFielderId: "",
			contactSearchInit: !UserConfigService.getGeneralSettings().ShowSupplierFilterOnPriceListOpen,
			views: [] as MongoView[],
			selectedView: new MongoView(),
			manageViewsModalOpen: false
		};
	},
	props: {
		search: String,
		forSale: Boolean
	},
	computed: {
		filterOnCurrentContactIcon():string{
			if (this.supplierFielderId!==""){
				return "users-slash";
			}
			return "users";
		},
		// eslint-disable-next-line max-lines-per-function
		columns():IDataTableColumn[] {
			return this.selectedView.getDataTableCols(getPriceListViewColumns());
		},
		addDisabled():boolean {
			if (this.selectedItems.length == 0) return true;
			if (this.selectedItems[0].ProductID != 0) return true;
			return false;
		},
		viewItems():ISelectItem<MongoView>[] {
			return this.views.map(v=>{
				return {
					text: v.Name,
					value: v
				};
			});
		}
	},
	methods: {
		closeContactSearch(){
			this.showContactSearch=false;
			if(!this.contactSearchInit){
				this.contactSearchInit = true;
				this.fetch();
			}
		},
		toggleSupplierSearch(){
			this.contactSearchInit = true;
			this.showContactSearch = !this.showContactSearch;
			this.supplierFielderId = "";
			this.contact = null;
			this.fetch();
		},
		onSupplierSelect(supplier:Contact){
			this.contactSearchInit = true;
			this.supplierFielderId = supplier.ComputedFriendlyID;
			this.fetch();
			this.showContactSearch = false;
		},
		close(){
			this.$emit("close");
		},
		async clearSearchQuery(){
			this.searchText="";
			this.items=[];
			await this.fetch();
		},
		async fetch(more:boolean = false){
			if(!this.contactSearchInit){
				return;
			}
			this.searchQuery = this.searchText;
			this.$emit("search-changed", this.searchQuery);
			if (this.isFetching) return;
			this.isFetching = true;
			try{
				let result = await PriceListProductService.fetch(this.searchQuery, {
					limit: this.limit,
					offset: more ? this.items.length : 0,
					orderBy: this.orderColumn,
					orderDirection: this.orderAsc ? "ASC" : "DESC",
				},{supplierNr: this.supplierFielderId});
				const mappedData = result.data.map((item: any) => ({
					...item,
					Disabled: item.ProductID != 0
				}));
				if (more){
					this.items.push(...mappedData);
				}else{
					this.selectedItems.splice(0,this.selectedItems.length);
					this.items = mappedData;
				}
				this.totalItems = result.records;
			}catch(err){

			}
			this.isFetching = false;
		},
		onScroll(event:Event){
			let table = event.target as HTMLElement;
			let lastChild = table.lastChild as HTMLElement;
			if (!lastChild) {
				return;
			}

			let tableRect = table.getBoundingClientRect();
			let childRect = lastChild.getBoundingClientRect();


			let tableBottomY = tableRect.top + tableRect.height;
			if (childRect.top < (tableBottomY + 4000) && !this.isFetching) {
				this.fetch(true);
			}
		},
		onOrderChanged(order: {order:any, ascending:boolean}) {
			this.orderColumn = order.order;
			this.orderAsc = order.ascending;
			this.fetch();
		},
		async createProduct(value:any){
			try{
				let foundProduct = await ProductService.findBySku(value.Sku);
				if (foundProduct) {
					this.$wf.notify(this.$ct("product-already-exists"), "danger", 3000, "exclamation-triangle");
					return;
				}
			}catch(err){
				let hErr = err as HttpError;
				hErr.dontShow = true;
			}
			let p = await PriceListProductService.toProduct(value);
			p.Active = true;
			let product = await ProductService.postProduct(p);
			this.$emit("product-created",product);
			this.close();
			if(!this.forSale){
				this.$router.push(`/products/info/${product.ID}`);
			}
			return;
			//this.close();
			//this.$router.push(`/products/new?priceListJson=${encodeURIComponent(JSON.stringify(value))}`);
		},
		async deleteSelected(){
			await PriceListProductService.deleteItems(this.selectedItems.map(i=>i.ID));
			this.fetch();
		},
		openExcelMapper(){
			this.excelMapperOpen = true;
		},
		manageViews(){
			this.manageViewsModalOpen = true;
		},
		async onManageViewsModalClosed(){
			this.views = await MongoViewService.getByType(MongoViewTypes.PRICE_LISTS);
			this.manageViewsModalOpen = false;
			let selectedView = this.views.find(v=>v.ID == this.selectedView.ID) || this.views[0];
			if (!selectedView){
				await MongoViewService.createView(getDefaultPriceListView());
				this.views = await MongoViewService.getByType(MongoViewTypes.PRICE_LISTS);
				selectedView = this.views[0];
			}
			this.selectedView = selectedView;
		}
	},
	async mounted(){
		if(this.search){
			this.searchText = this.search;
		}
		this.views = await MongoViewService.getByType(MongoViewTypes.PRICE_LISTS);
		if (this.views.length == 0) {
			await MongoViewService.createView(getDefaultPriceListView());
			this.views = await MongoViewService.getByType(MongoViewTypes.PRICE_LISTS);
		}
		this.selectedView = this.views[0];
		await this.fetch();
	},
	components: {
		AppImportCsvModal,
		AppExcelMapper,
		AppTag,
		AppContactSearch,
		AppViewsEditModal
	},
	i18nEx: {
		componentPrefix: "components.price-lists"
	}
});
